export const getReplyMessageType = ({
  isEmailChannel,
  replyType,
  privateMessageReplyMode,
}) => {
  if (
    isEmailChannel ||
    typeof privateMessageReplyMode !== 'string' ||
    !privateMessageReplyMode
  ) {
    return '';
  }

  return replyType === privateMessageReplyMode.toUpperCase()
    ? privateMessageReplyMode
    : '';
};
